/* src/app/shared/controls/tab-control/tab-control.component.scss */
.tab-control {
  display: flex;
  width: 100%;
  border-style: solid;
  border-top-width: 0;
  border-bottom-width: 3px;
  border-left-width: 0;
  border-right-width: 0;
  border-color: #1b638b;
  align-items: flex-end;
  cursor: pointer;
}
.tab {
  position: relative;
  display: flex;
  align-items: center;
}
.tab:before,
.tab:after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 10px;
  height: 10px;
  z-index: 1;
}
.tab:before {
  left: -10px;
}
.tab:after {
  right: -10px;
}
.tab span {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  color: #000000;
  background: rgb(242.25, 242.25, 242.25);
  border-style: solid;
  border-width: 1px;
  border-color: rgb(222.25, 222.25, 222.25);
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}
.tab span:before,
.tab span:after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  z-index: 2;
}
.tab span:before {
  left: -20px;
}
.tab span:after {
  right: -20px;
}
.tab.active {
  z-index: 3;
}
.tab.active:before,
.tab.active:after {
  background: #1b638b;
}
.tab.active span {
  background: #1b638b;
  color: #ffffff;
  border-color: #1b638b;
}
.tab.active span:after,
.tab.active span:before {
  background: rgb(242.25, 242.25, 242.25);
}
.tab.active:first-child:before {
  background: #ffffff;
}
.tab.active:first-child span:before {
  background: #ffffff;
}
.tab.active:last-child:after {
  background: #ffffff;
}
.tab.active:last-child span:after {
  background: #ffffff;
}
.tab:last-child:after,
.tab:last-child span:after,
.tab:first-child:before,
.tab:first-child span:before,
.tab.active:after,
.tab.active:before,
.tab.active span:after,
.tab.active span:before {
  content: "";
}
.tab-icon {
  margin-right: 5px;
}
/*# sourceMappingURL=tab-control.component-6HLH3PKO.css.map */
